export default __webpack_public_path__ + "static/media/no-order.89ce6f5f.png";